export function roundNumber(number, precision) {
  const factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}

export function formatCurrency(value, currency = 'AED', precision = 2) {
  const formattedValue = roundNumber(value, precision).toFixed(precision);
  return `${currency} ${formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}
